import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type {
  GetMerchantCategoriesRequest,
  GetMerchantCategoriesResponse,
  GetMerchantDetailResponse,
  GetMerchantCategoryCodeResponse,
  GetMerchantCategoryCodeRequest,
  CreateMerchantCategoryCodeRequest,
  UpdateMerchantInfomationRequest,
  UpdateMerchantInfomationResponse,
  CreateMerchantRequest,
} from "./types";
import { baseQueryCreator } from "redux/baseQuery";
import env from "env";

const { merchantService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: merchantService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const merchantApi = createApi({
  reducerPath: "merchantApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  tagTypes: ["MerchantCagegoriesList"],
  endpoints: (builder) => ({
    getMerchantDetail: builder.query<GetMerchantDetailResponse, { merchantId: string; orgToken?: string }>({
      query: ({ merchantId, orgToken }) => {
        return {
          url: `merchants/${merchantId}`,
          method: "GET",
          headers: orgToken ? {
            "org-token": orgToken,
          } : undefined,
        };
      },
    }),
    getMerchantCagegories: builder.query<
      GetMerchantCategoriesResponse,
      GetMerchantCategoriesRequest
    >({
      query: (params) => {
        return {
          url: `merchant-categories`,
          method: "GET",
          params,
        };
      },
    }),
    updateMerchantInfomation: builder.mutation<
      UpdateMerchantInfomationResponse,
      UpdateMerchantInfomationRequest
    >({
      query: ({ merchantId, ...payload }) => {
        return {
          url: `merchants/${merchantId}`,
          method: "PATCH",
          body: payload,
        };
      },
    }),
    getMerchantCategoryCode: builder.query<
      GetMerchantCategoryCodeResponse,
      GetMerchantCategoryCodeRequest
    >({
      query: (params) => {
        return {
          url: `merchant-categories`,
          method: "GET",
          params,
        };
      },
    }),
    createMerchantCategoryCode: builder.mutation<
      {},
      CreateMerchantCategoryCodeRequest
    >({
      query: (body) => {
        return {
          url: `merchant-categories`,
          method: "POST",
          body,
        };
      },
    }),
    updateMerchantCategoryCode: builder.mutation<
      {},
      CreateMerchantCategoryCodeRequest
    >({
      query: (body) => {
        return {
          url: `merchant-categories/${body.id}`,
          method: "PUT",
          body,
        };
      },
    }),
    deleteMerchantCategoryCode: builder.mutation<{}, { id: string }>({
      query: ({ id }) => {
        return {
          url: `merchant-categories/${id}`,
          method: "DELETE",
        };
      },
    }),
    createMerchant: builder.mutation<{}, CreateMerchantRequest>({
      query: (payload) => ({
        url: `/merchants`,
        method: "POST",
        body: {
          ...payload,
        },
      }),
    }),
  }),
});

export const {
  useGetMerchantDetailQuery,
  useGetMerchantCategoryCodeQuery,
  useCreateMerchantCategoryCodeMutation,
  useUpdateMerchantCategoryCodeMutation,
  useDeleteMerchantCategoryCodeMutation,
  useGetMerchantCagegoriesQuery,
  useUpdateMerchantInfomationMutation,
  useCreateMerchantMutation,
} = merchantApi;
export const { useQueryState: useGetWalletByOrgIdQueryState } =
  merchantApi.endpoints.getMerchantDetail;
